<template>
	<div class="time-widget">
		<div
			class="subtract"
			@click="subtract"
		>
			<Icon
				icon-name="left-arrow"
				size="sm"
			/>
		</div>
		<div class="time-input">
			<span>{{ value }}</span>
			<span>{{ trans('commons.second_abbr') }}</span>
		</div>
		<div
			class="add"
			@click="add"
		>
			<Icon
				icon-name="right-arrow"
				size="sm"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name:  'DurationInput',
	props: {
		max: {
			type:    Number,
			default: 60,
		},
		value: {
			type:    Number,
			default: 5,
		},
	},
	methods: {
		add() {
			this.$emit('input', Math.min(this.value + 1, this.max));
		},
		subtract() {
			this.$emit('input', Math.max(this.value - 1, 0));
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import "@videotools/sass/fonts.scss";

.time-widget {
	display: flex;
	align-items: center;
	width: 100%;

	.subtract, .add {
		border: 1px solid var(--color-grey-300);
		border-radius: 18px;
		color: var(--color-soft-white);
		cursor: pointer;
		padding: 8px;
	}

	.subtract {
		margin-right: 16px;
	}

	.add {
		margin-left: 16px;
	}

	.time-input {
		width: 108px;
		border: 1px solid var(--color-grey-700);
		border-radius: 2px;
		padding: 7px 0 7px 30px;

		span:first-child {
			@include text-lg-1;
		}

		span:nth-child(2) {
			@include text-sm-2;
			color: var(--color-grey-300);
		}
	}
}
</style>
